import React, { Component } from 'react';
import './_app.css';
import './Fonts.css';
import './MediaQuery.css';
import $ from 'jquery';
import _ from 'lodash';
import SidebarLeft from './sidebar/SidebarLeft';
import Conteudo from './conteudo/Conteudo';
import HeaderBar, { WarningNotification } from './headerbar/';
import { ChatView, ChatRow } from './chatview';
import InputMensagem from './inputmensagem/Input';
import moment from 'moment';
import 'moment/locale/pt-br';
import SideMenu from './sidemenu/SideMenu';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Firechat from '../utils/Firechat';
import NotificationsManager from '../utils/NotificationsManager';
import ContatosActions, { getCurrentContact } from '../redux/contatoStore';
import { getUser } from '../redux/loginStore';
import { Users } from '../utils/Users';
import { head, pick } from 'lodash/fp';
import { isNotNil, isChatAssignedToUser } from '../utils';
import {hasDepartmentConfig} from "../functions/config";

const avatar = require('../img/icons/avatar.png');
const iconDeps = require('../img/icons/share.png');

class Chat extends Component {

  state = {
    otherRooms: [],
    chats: [],
    conversations: [],
    selectedContact: null,
    selectedChat: null,
    isLoadingMore: false,
    event: '',
    shouldInit: null,
    notificationStatus: "granted"
  }

  componentWillMount() {
    const { user } = this.props;

    if (!user) return false;

    this._chat = Firechat.getInstance(user.licenca);

    this._chat.setUser(user.id, user.nome, () => {

      if (Users.isSuporte(this.props.user)) {
        this._chat.getAllChats();
      }
      else {
        this._chat.getChats();
      }
      this._chat.on('chat-add', (chats) => {
        this.checkChatIsOpen(chats).then(() => this.prepareConversations(chats)
          .then(conversations => {
            this.setState({ conversations, event: 'chat-add' }, ()=>{
              this.setNotificationInTitlePage();
            });
          })
        )
      });
  
      this._chat.getOtherRooms((value) => {
        const { user } = this.props;
        const { configuracoes } = user;
        let otherRooms;

        user.ids_departamentos.push(null);
  
        value = value ? Object.values(value) : [];
        // se tiver usando configuração de departamentos filtra chats do departamento do usuario logado ou sem departamentos
        if (hasDepartmentConfig(configuracoes)) {
          otherRooms = _.filter(value, item => {
            if(!item.departmentId){
              return true;
            }
            return user.ids_departamentos && user.ids_departamentos.includes(item.departmentId);
          })
        }
        else {
          otherRooms = value;
        }

        this.setState({ otherRooms }, ()=>{
          this.setNotificationInTitlePage();
        });
      });
      // setando usuario com foco no chat
      this._chat.setChatFocused(true);
      // setando webtoken
      !window.__DEV__ && this.initToken();
    });

    this._chat.on('room-enter', () => {
      this.setState({ chats: [], event: 'room-enter' });
    });

    this._chat.on('message-add', (roomId, message) => {

      if (this.state.selectedChat && this.state.selectedChat.id !== roomId) return false;

      this.setState(({ chats }) => ({
        chats: [...chats, message],
        event: 'message-add'
      }));
    });


    $(document).on('visibilitychange', e => {
      if (e.target.visibilityState === 'visible') {
        this._chat.setChatFocused(true);
      } else if (e.target.visibilityState === 'hidden') {
        this._chat.setChatFocused(false);
      }
    });
  }

  componentWillUnmount() {
    $(document).off('visibilitychange')
  }

  checkChatIsOpen = async (chats) => {
    chats.forEach(conversation => {
      if (this.state.selectedChat && this.state.selectedChat.id === conversation.key) {
        this._chat.setAsRead(conversation.key);
        conversation.read = true;
      }
    });

    return chats;
  }

  prepareConversations = (chats) => {
    const { user } = this.props;
    return Promise
        .all(chats.map(conversation => this._chat.getRoom(conversation.key)))
        .then(rooms => chats.map(conversation => {
            if(conversation.status){
              return conversation;
            }

            return {
              ...conversation,
              status: rooms
                  .some(room => room.id === conversation.key && isChatAssignedToUser(room, user)) ?
                  'open' : 'closed'
            };
        }));
  }

  initToken() {
    let { user } = this.props;
    user = pick(['email', 'licenca', 'id'], user);
    const subscriptionChange = ()=>this.hideWarning()

    NotificationsManager.init({user, subscriptionChange});

    NotificationsManager.getStatusPermission()
    .then(res => {
      this.setState({notificationsStatus: res}, ()=>{
        if( res === "denied" || res === "default" )
          $("#header-notifications-info").slideDown();
      });
    })
  }

  hideWarning = () => {
    $("#header-notifications-info").slideUp();
  }

  setNotificationInTitlePage = ()=>{
    const { otherRooms, conversations } = this.state;
    const totalNotifications = conversations.filter(item => item.read === false && item.status === 'open').length + otherRooms.filter(item => item.waiting === true && item.name).length || 0;
    document.title = totalNotifications > 0 ? `(${totalNotifications}) Owli - Chat` : "Owli - Chat";
  }

  clearMessages = () => this.setState({chats: []});

  onContactClick = (contact) => {
    const contactId = contact.id_pessoa_pes;
    const { selectedChat } = this.state;

    if(selectedChat)
      this._chat.leaveRoom(selectedChat.id);

    this._chat.checkIfRoomExists(contactId)
      .then(roomRef => {
        if(roomRef){
          this.setState({
            selectedChat: roomRef,
            shouldInit: !isChatAssignedToUser(roomRef, this.props.user)
          });
          this._chat.checkIfChatExists(roomRef.id)
          .then(chatKey => {
            if(chatKey){
              this.onConversationClick(chatKey, contactId, contact.st_nome_pes);
            } else {
              this._chat.enterRoom(roomRef.id, contact.st_nome_pes, true)
                .then(room => this.setStatePromisified({selectedChat: room}));
            }
          });
        } else {
          this.clearMessages();
          this.setState({ selectedChat: null, shouldInit: true});
        }
        this.props.dispatch(ContatosActions.selectContact(contactId));
      });
  }

  setStatePromisified = (state) => new Promise(resolve => this.setState(state, resolve));


  onConversationClick = (roomId, contactId, guestName = null)=>{

    const { currentContact } = this.props;
    const { selectedChat } = this.state;

    if(selectedChat){
      this._chat.leaveRoom(selectedChat.id);
    }

    if(currentContact && currentContact.id_pessoa_pes == contactId) return;

    this._chat.enterRoom(roomId, guestName, true)
    .then(room => this.setStatePromisified({selectedChat: room, shouldInit: !isChatAssignedToUser(room, this.props.user)}))
    .then(() => this._chat.setAsRead(roomId))
    .then(() => this.props.dispatch(ContatosActions.selectContact(contactId)))
    .catch(console.error);
  }

  onWaitingUserClick = (user)=>{
    this._chat.enterRoom(user.id)
    .then(room => this.setStatePromisified({
      selectedChat: room,
      shouldInit: !isChatAssignedToUser(room, this.props.user)
    }));
    this.props.dispatch(ContatosActions.selectContact(user.name));
  }

  finalizarChat = (roomId, guestId)=>{
    const confirm = window.confirm('Tem certeza que deseja finalizar a conversa atual ?')
    if(!confirm) return;
    this._chat.closeChat(roomId, guestId);
    this.setState({ selectedChat: null});
    this.props.dispatch(ContatosActions.selectContact());
  }

  renderChats = (item, index)=>{
    const { chats } = this.state
    let showAvatar = false
    const date = moment(new Date(Number.parseInt(item.timestamp))).fromNow();
    const isSender = item.type == "system" ? true : false;
    const _proxima = chats[index + 1] || []

    if (item.type === _proxima.type) {
      showAvatar = true
    }

    if (item.isWidget === true) {
      switch (item.widgetType) {
        case 'new_conversation':
          return (
          <p className="widget-chat">
            Conversa iniciada com o departamento {item.message}
          </p>
          );
        case 'changed_department':
          return (
            <p className="widget-chat">
              <img src={iconDeps} width="16" height="14" />
              Encaminhada para o departamento {item.message}
            </p>
          );
        case 'new_conversation2':
        case 'finished_conversation':
            return (
              <p className="widget-chat">
                {item.message}
              </p>
            );
        default:
          return null;
      }
    }

    return (
      <li>
        <ChatRow
          avatar={avatar}
          conteudo={item.message}
          data={date}
          sender={isSender}
          showAvatar={showAvatar}
        />
      </li>
    )
  }

  changeDepartment = (itemKey, optionId, optionLabel, guestId) => {
    this._chat.changeDepartment(itemKey, optionId, optionLabel, guestId, () => {
      this.setState({ selectedChat: null, selectedContact: null, chats: [] })
      this.props.dispatch(ContatosActions.selectContact());
    })
  }

  sendMessage = (message) => {
    
    return new Promise(resolve => {
      this._chat.sendMessage(null, message, null, () => {
        const { currentContact } = this.props;
        const tokenPush = currentContact && currentContact.id_pushmobile_put ? currentContact.id_pushmobile_put : null;
        const _user = {
          isOnline: false,
          tokenPush
        };
        NotificationsManager.sendNotification(message, _user);
        this.setState({
          event: 'send-message'
        });
        resolve();
      });
    });
  }

  onSubmitMessage = (message) => {
    const { shouldInit } = this.state;

    if(shouldInit){
      return this.initChat(this.props.currentContact)
        .then(() => this.sendMessage(message))
    }
    return this.sendMessage(message);
  }

  loadMoreMessages = () => {
    const { chats = [], selectedChat, isLoadingMore } = this.state;
    const olderMessage = head(chats);
    if (!isLoadingMore) {
      this.setStatePromisified({isLoadingMore: true})
        .then(() => this._chat.previousMessages(selectedChat.id, olderMessage.id))
        .then(messages => this.setState(({ chats }) => ({
          chats: [...messages, ...chats],
          event: 'load-more'
        })))
        .then(() => this.setStatePromisified({isLoadingMore: false}));
    }
  }

  initChat = (contact = {}) => {

    const { user } = this.props;

    if( Users.isSuporte(user) )
      return alert("Usuário Suporte não pode iniciar conversa")

    const {
      selectedChat
    } = this.state;

    const {
      id_pessoa_pes: contactId,
      st_nome_pes: contactName
    } = contact;

    const confirm = window.confirm(`Tem certeza que deseja iniciar uma conversa com ${contactName}`);
    if(!confirm) return Promise.reject();

    const hasSelectedChat = isNotNil(selectedChat);

    if(!hasSelectedChat){
        return this._chat.createRoom(contactId, null, contactName)
        .then(room =>
            this._chat.joinUserAppToRoom(contactId, contactName, room.id)
                .then(() => this.createConversation(room, contactName, contactId)));
      }

      return this.createConversation(selectedChat, contactName, contactId);
  }

  createConversation = (room, contactName, contactId) => {
    const { user } = this.props;

    const userHasDepartment = !!(room && user.ids_departamentos.includes(room.departmentId));

    return this._chat.newConversation(
        room.id,
        contactName,
        contactId,
        room.lastMessage,
        userHasDepartment ? room.departmentId : null,
        userHasDepartment ? room.departmentName : ''
    )
        .then(room => this.setStatePromisified({
          selectedChat: room,
          shouldInit: !isChatAssignedToUser(room, this.props.user)
        }))
        .then(() => this.sidebarLeftTabs._handleOnClick(0));
  }

  render() {
    const {
      chats, conversations,
      otherRooms, selectedContact,
      selectedChat, event,
      isLoadingMore,
      shouldInit,
      notificationsStatus
    } = this.state;

    const { user } = this.props;

    const { ids_departamentos, id } = user;

    const hasSelectedChat = isNotNil(selectedChat);

    const selectedChatId = hasSelectedChat ? selectedChat.id : 0;

    const chatMetaData =  hasSelectedChat ? _.filter(conversations, conv => conv.key === selectedChatId) : [];

    const hasDepartment = !!(hasSelectedChat && selectedChat.departmentId && ids_departamentos.some(department => department === selectedChat.departmentId));

    const canInitChat = !!(hasSelectedChat && ((hasDepartment || !selectedChat.departmentId)|| (!selectedChat.attendentId || selectedChat.attendentId === id)));

  
    return (

      <div className="container">
        <WarningNotification
          notificationsStatus={notificationsStatus}
          hideWarning={this.hideWarning}
          showPrompt={() => NotificationsManager.showPromptPermission()}
          />
        <div className="content">
          <SidebarLeft
            tabsRef={tabs => this.sidebarLeftTabs = tabs}
            user={this.props.user}
            onWaitingUserClick={this.onWaitingUserClick}
            onConversationClick={this.onConversationClick}
            onContactClick={this.onContactClick}
            conversations={conversations}
            otherRooms={otherRooms || []}
            selectedChat={selectedChatId}
            shouldInit={shouldInit}
          />
          <Conteudo>
            <HeaderBar
              conversation={chatMetaData[0] || {}}
              changeDepartment={this.changeDepartment}
              currentChat={selectedChat}
              onFinishChat={this.finalizarChat}
              initChat={this.initChat}
              shouldInit={shouldInit}
            />
            <ChatView
              selectedChat={selectedChatId}
              loadMoreMessages={this.loadMoreMessages}
              isLoadingMore={isLoadingMore}
              chats={chats}
              event={event}
              renderChats={this.renderChats}
            >
              {canInitChat &&
                <InputMensagem onSubmitMessage={this.onSubmitMessage} shouldInit={shouldInit}/>
              }
            </ChatView>
          </Conteudo>
          <SideMenu idContact={selectedContact} />
          {/* <SideBarMenu/> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    currentContact: getCurrentContact(state)
  }
}
export default connect(mapStateToProps)(withRouter(Chat));



// WEBPACK FOOTER //
// ./src/components/Chat.js